import dayjs from 'dayjs';
import { Application } from '~/types/Application';
import { getStagePayload } from './getStagePayload';

export const isResubmit = (application: Application | undefined): boolean => {
  const stagePayload = getStagePayload.wizard(application);
  if (!stagePayload) return false;

  const isLastReviewResubmit =
    application?.payload?.completeReview
      ?.filter(({ date }) => !!date)
      ?.sort(({ date: date1 }, { date: date2 }) => {
        return dayjs(date2).diff(dayjs(date1));
      })?.[0]?.decision === 'RESUBMIT';

  return isLastReviewResubmit;
};
